<!--
Based on the original file BibleDetail created for Rigoberto Osorio <rigoberto.osorio@uneatlantico.es>
-->
<template>
    <div>
        <data-gathering-card-loading v-if="loading" />
        <v-card
            v-else
            class="bible-card"
            elevation="0"
            :loading="dataGatheringInfo.is_loading"
        >
            <data-gathering-card-title
                :dataGathering="dataGathering"
            />
            <v-card-text>
                <v-row>
                    <v-col md="6" cols="12" sm="12" class="px-0 py-0">
                        <v-list>
                            <v-list-item>
                                <v-list-item-title class="bible__title-item label">
                                    {{ $t('data_gatherings.status') }}:
                                </v-list-item-title>
                                <v-list-item-subtitle class="bible__subtitle-item body-text">
                                    <v-chip
                                        :class="dataGatheringInfo.status_classes"
                                        label
                                    >
                                        {{ dataGatheringInfo.status }}
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title class="bible__title-item label">
                                    {{ $t('data_gatherings.type') }}:
                                </v-list-item-title>
                                <v-list-item-subtitle class="bible__subtitle-item body-text">
                                    <span>{{ dataGatheringInfo.type }}</span>
                                </v-list-item-subtitle>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title class="bible__title-item label">
                                    {{ $t('data_gatherings.version') }}:
                                </v-list-item-title>
                                <v-list-item-subtitle class="bible__subtitle-item body-text">
                                    <span>
                                        {{ dataGatheringInfo.strategy }} - <b>{{ dataGatheringInfo.mode }}</b>
                                    </span>
                                </v-list-item-subtitle>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col md="6" cols="12" sm="12" class="px-0 py-0">
                        <v-list>
                            <v-list-item>
                                <v-list-item-title class="bible__title-item label">
                                    {{ $t('data_gatherings.created_by') }}:
                                </v-list-item-title>
                                <v-list-item-subtitle class="bible__subtitle-item body-text">
                                    <span>{{ dataGatheringInfo.created_by }}</span>
                                </v-list-item-subtitle>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title class="bible__title-item label">
                                    {{ $t('data_gatherings.created_at') }}:
                                </v-list-item-title>
                                <v-list-item-subtitle class="bible__subtitle-item body-text">
                                    <span>{{ dataGatheringInfo.created_at }}</span>
                                </v-list-item-subtitle>
                            </v-list-item>

                            <template v-if="dataGathering.approved_at">
                                <v-list-item>
                                    <v-list-item-title class="bible__title-item label">
                                        {{ $t('data_gatherings.approved_by') }}:
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="bible__subtitle-item body-text">
                                        <span>{{ dataGatheringInfo.approved_by }}</span>
                                    </v-list-item-subtitle>
                                </v-list-item>

                                <v-list-item>
                                    <v-list-item-title class="bible__title-item label">
                                        {{ $t('data_gatherings.approved_at') }}:
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="bible__subtitle-item body-text">
                                        <span>{{ dataGatheringInfo.approved_at }}</span>
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </template>

                            <v-list-item>
                                <v-list-item-title class="bible__title-item label">
                                    {{ $t('data_gatherings.updated_at') }}:
                                </v-list-item-title>
                                <v-list-item-subtitle class="bible__subtitle-item body-text">
                                    <span>{{ dataGatheringInfo.updated_at }}</span>
                                </v-list-item-subtitle>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-row>
                    <v-col class="px-0 py-0">
                        <v-list>
                            <v-list-item>
                                <v-list-item-title
                                    class="bible__title-item bible__title-item--note label"
                                >
                                    <b>{{ $t('data_gatherings.notes') }}:</b>
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    class="bible__subtitle-item bible__subtitle-item--break-spaces"
                                >
                                    <span>{{ dataGatheringInfo.notes }}</span>
                                </v-list-item-subtitle>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import DataGatheringRepository, {busyStatuses} from "@/Repositories/DataGathering/DataGatheringRepository";
import DataGatheringCardLoading from "@/Shared/DathaGatherings/Common/DataGatheringCardLoading";
import DataGatheringCardTitle from "@/Shared/DathaGatherings/Common/DataGatheringCardTitle";

export default {
    name: "DataGatheringCard",

    components: {DataGatheringCardTitle, DataGatheringCardLoading},

    props: {
        dataGathering: {
            type: Object,
            default: DataGatheringRepository.build(),
        }
    },

    data: () => ({
        loading: false,
    }),

    methods: {

    },

    computed: {
        dataGatheringInfo() {
            return {
                type: _.get(this.dataGathering, 'type.title', '-'),
                strategy: _.get(this.dataGathering, 'strategy.title', '-'),
                status: this.$t(`data_gatherings.statuses.${this.dataGathering.status}`),
                status_classes: `chip__status chip__status--${this.dataGathering.status}`,
                mode: _.get(this.dataGathering, 'options.data_provider.name', '-'),
                notes: _.get(this.dataGathering, 'notes', '-'),
                created_by: _.get(this.dataGathering, 'options.created_by.name', '-'),
                created_at: this.$options.filters.asDateTime(this.dataGathering.created_at),
                approved_by: _.get(this.dataGathering, 'options.approved_by.name', '-'),
                approved_at: this.$options.filters.asDateTime(this.dataGathering.approved_at),
                updated_at: this.$options.filters.asDateTime(this.dataGathering.updated_at),
                is_loading: busyStatuses.inArray(_.get(this.dataGathering, 'status')),
            };
        },
    },

    filters: {
        asDateTime(time){
            if(!time)
                return '-';

            time = dayjs(time);

            if(!time.isValid())
                return 'invalid';

            return time.format('YYYY-MM-DD HH:mm:ss')
        },
    }
}
</script>

<style scoped>

</style>
